var bookshelf = require("../index-extended");
require("./Meeting");
require("./ResolutionCatalog");
require("./Majority");
require("./Media");

module.exports = bookshelf.model("Resolution", {
  entityName: "Resolution",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "resolution",
  resolutions_catalog() {
    return this.belongsTo("ResolutionCatalog");
  },
  majority() {
    return this.belongsTo("Majority");
  },
  // ???: ??
  // meetings() {
  //   return this.belongsToMany("Meeting", "meeting_resolution", "resolution_id", "meeting_id");
  // },
  media() {
    return this.hasMany("Media", "resolution_id");
  },
  // children meeting resolutions
  children_resolutions() {
    return this.hasMany("Resolution", "parent_resolution_id");
  },

  format(attrs) {
    delete attrs["$id"];
    delete attrs["voting_category"];
    delete attrs["majority"];
    delete attrs["media"];
    delete attrs["children_resolutions"];

    delete attrs["meeting_id"];
    delete attrs["voting_category_id"];
    delete attrs["status"];

    return attrs;
  },
});
